import React from 'react'
import ResourcesDropdown from './ResourcesDropdown'

const SolutionsDropdown = ({ show, getLink, mobile = false }) => {
    return (
        <div
            className={`dropdown-menu--js-target solutions-dropdown ${
                show ? 'show' : ''
            }`}
        >
            <div className="solutions-list">
                <h1>Solutions for</h1>

                <ul>
                    <li>{getLink('/agents', 'Agents')}</li>
                    <li>{getLink('/teams', 'Teams')}</li>
                    <li>
                        {getLink(
                            '/brokers',
                            <span>
                                Brokerages & <br />
                                Franchisors
                            </span>
                        )}
                    </li>
                    <li>{getLink('/mls/connect', 'MLSs')}</li>
                </ul>
            </div>
            <div className="solutions-dropdown__products-list">
                <h1>Products</h1>
                <ul>
                    <li className="boost">
                        {getLink('/boost', 'Boost')}
                        <p>Advertising automation</p>
                    </li>
                    <li className="spacio">
                        {getLink('/spacio', 'Spacio')}
                        <p>Open house lead generation system</p>
                    </li>
                    <li className="connect">
                        {getLink('/connect', 'Connect')}
                        <p>Mobile apps for collaboration on the go</p>
                    </li>
                    <li className="leadsPlus">
                        {getLink('/agents/leadsPlus', 'Leads+')}
                        <p>Lead generation done for you</p>
                    </li>
                </ul>
            </div>
            {mobile ? (
                <React.Fragment>
                    <ResourcesDropdown show={true} getLink={getLink} />
                    <div className="border" />
                    {mobile}
                </React.Fragment>
            ) : null}
        </div>
    )
}

export default SolutionsDropdown
